<template>
  <div class="quote-tab">
    <!--    <h1>Policies</h1>-->
    <div class="filter-top-select">
      <span
        :class="{'is_active':is_share==0}"
        @click="handleChange(0)">{{ isFina?'Referred':'Self' }}</span>
      <span
        v-if="!isFina"
        :class="{'is_active':is_share==1}"
        @click="handleChange(1)">Authorized</span>
      <span
        v-if="isPro"
        :class="{'is_active':is_share==3}"
        @click="handleChange(3)">Referred Policy</span>
      <span
        v-if="!isFina&&isPro"
        :class="{'is_active':is_share==2}"
        @click="handleChange(2)">Fina Policy</span>
    </div>
    <div class="filter-card">
      <div class="filter-top">
        <div class="search-box">
          <v-input
            v-model="search"
            :prefixIcon="'el-icon-search'"
            placeholder="Policy No., Cover Note No., Ref., Endorsement No., Customer Name, Contact, Referrer, VRD"
            @keyEnter="filterData" />
        </div>
      </div>

      <div class="filter-main">
        <div class="filter-left">
          <!--          <div class="form-item">-->
          <!--            <span>Creation Date</span>-->
          <!--            <v-date-picker-->
          <!--              v-model="date"-->
          <!--              type="daterange"-->
          <!--              @change="filterData" />-->
          <!--          </div>-->
          <!--          <div class="form-item">-->
          <!--            <span>Assignee</span>-->
          <!--            <span>-->
          <!--              <v-select-->
          <!--                v-model="cs_id"-->
          <!--                icon="user-nurse"-->
          <!--                :clearable="true"-->
          <!--                :list="assgineeList"-->
          <!--                @change="filterData" />-->
          <!--            </span>-->
          <!--          </div>-->
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe')">None</span>
            </span>
            <v-checkbox-group
              v-model="effe_id"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
        <div
          class="filter-right"
        >
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange-light': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>

    </div>

    <policy-table
      :customerId="customerId"
      :is-fina="isFina"
      :filters="filterParams"></policy-table>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getAccountPolicyList} from '@/api/account'
import PolicyTable from '@/views/components/policy-table'
import { mapState } from 'vuex'

export default {
  name: 'PoliciesTab',
  components:{
    PolicyTable
  },
  mixins: [MixinOptions],
  props: {
    // customerId: [String, Number]
  },
  inject:['customer_id','merchant_platform','detailData'],
  data() {
    return {
      is_share:0,
      date: '',
      class_id: [],
      company_id: [],
      stts: [1, 2, 3, 4],
      effe_id: [],
      tags: [],
      search: '',
      tableData: [],
      cs_id: '',
      filters: {}
    }
  },
  computed: {
    ...mapState('account', ['customerFilter']),
    customerId(){
      return this.customer_id()
    },
    isFina(){
      let merchant_platform = this.merchant_platform()
      return merchant_platform ==2
    },
    isPro(){
      let {customer_profile={}} = this.detailData()
      let {vip_level = -1 } = customer_profile||{}
      return vip_level != - 1
    },
    customerInfo(){
      return this.customer_profile()
    },
    extra_show(){
      return (row,index)=>{
        let textData = {}
        if(!row) return ''
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        return textData.id
      }
    },
    extra_tip(){
      return (row,index)=>{
        let textData = {}
        Object.entries(row).filter(item=>{
          if(item[1].id == index)
            textData = item[1]
        })
        if(textData)
          return textData.name

      }
    },
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    tagsOptions() {
      return this.globalOptions.pcy_tag
    },
    classTypeOptions(){
      return this.globalOptions.class_data||[]
    },
    classOptions(){
      return (index)=>{
        let arr = this.classTypeOptions||[]
        let data = []
        data = index==1? arr.filter(item =>item.id>50): arr.filter(item =>item.id<50)
        return data
      }
    },
    assgineeList(){
      let arr =[{id:0,name:'All'}]
      let {assignee=[]} = this.globalOptions||{}
      return [...arr,...assignee]
    },
    filterParams(){
      let params = this.filters
      if(params.is_share == 2)
      {
        params.fina_policy = 1
        delete params.is_share
      }
      return params||{}
    }
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.customerFilter||{}
        Object.keys(policy).forEach(item=>{
          if(item != 'customer_id'){
            console.log(item)
            console.log(policy[item])

            this[item] = policy[item]
          }
        })
        this.filterData()
      }
    }
  },
  methods: {
    handlerSelectAll(target) {
      let origin = ''
      switch (target) {
        case 'class_id':
          origin = 'classTypeOptions'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe':
          origin = 'effeOptions'
          break
        case 'tags':
          origin = 'tagsOptions'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    handlerNoneAll(target) {
      this[target] = []
      this.filterData()
    },
    handleChange(data) {
      this.is_share = data
      this.filterData()
    },
    // todo 篩選還沒做
    filterData() {
      let params = {}
      if(this.is_share==3){
        params.is_referrer_share = 1
      }else {
        params.is_share = this.is_share
      }
      this.filters = {
        search: this.search,
        customer_id: this.customerId,
        effe_id: this.effe_id,
        stts: this.stts,
        ...params
      }

    },
  }
}
</script>
<style lang="scss" scoped>
.quote-tab {
    position: relative;
  ::v-deep .el-checkbox-group{
    align-items: start;
    flex-direction: column;
  }
    h1 {
        padding-bottom: 15px;
        color: #616266;
        font-size: 20px;
    }
    .top-right {
        position: absolute;
        top: 0;
        right: 0;
    }
  .span-name {
    display: block;
    color: #24292E;
  }
  .search-box {
    //margin-right: 20px;
    width: 100%;
  }
  .span-label {
    display: block;
    color: #24292E;
    font-weight: 500;
  }
  .form-half {
    & > span {
      display: block;
      padding-bottom: 5px;
      font-size: 14px;
      color: #6a737d;
    }
  }
  .span-status, .span-options {
    display: inline-block;
    //margin-right: 15px;
    padding: 1px 8px;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
    border-radius: 100px;
    //text-overflow: ellipsis;
    //width: 120px;
    max-width: 140px;
    word-break:keep-all;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
    .svg-inline--fa {
      margin-right: 5px;
      font-size: 14px;
    }
  }
  .span-status{
    &.green {
      background: #28a745;
      color: white;
    }
    &.orange {
      background: #E36209;
      color: white;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.red {
      background: #d73a49;
    }
    &.min-green {
      background: #dcffe4;
      color: #28a745;
    }
  }
  .span-options{
    border: 1px solid;
    &.gray {
      border-color: #586069;
      color: #586069;
    }
    &.green {
      border-color: #22863A;
      color: #22863A;
    }
    &.red {
      border-color: #D73A49;
      color: #D73A49;
    }
    &.gold {
      border-color: #735C0F;
      color: #735C0F;
    }
    &.blue {
      border-color: #0366D6;
      color: #0366D6;
    }
    &.orange {
      border-color: #C24E00;
      color: #C24E00;
    }
    &.black {
      border-color: #24292E;
      color: #24292E;
    }
  }
  .icon-color{
    &.gray {
      color: #586069;
    }
    &.green {
      color: #22863A;
    }
    &.red {
      color: #D73A49;
    }
  }
  .filter-top-select{
    margin-bottom: 15px;
    border-bottom: 1px solid #E1E4E8;
    //padding-bottom: 16px;
    display: flex;
    span{
      padding: 12px 16px 10px 16px;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #586069;
      display: block;
      cursor: pointer;
      &.is_active{
        color: #24292E;
        border: 1px solid #E1E4E8;
        border-bottom: 0;
        background: #fff;
        margin-bottom: -1px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }
      &:first-child{
        margin-left: 10px;
      }
    }
  }
  .filter-card {
    margin-bottom: 15px;
    //background: white;
    //border: 1px solid #E1E4E8;

    .filter-top {
      display: flex;
      align-items: center;
      //padding: 15px;
      //border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        //padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      border-radius: 5px;
      background: white;
      margin-top: 20px;
      border: 1px solid #D1D5DA;
      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }
      .filter-left, .filter-middler, .filter-right, .filter-last {
        padding: 15px 0;
      }
      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;

      }
      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        border-right: 1px solid #E1E4E8;
        flex: 2;
      }
      .filter-right {
        padding-left: 10px;
        border-right: 1px solid #E1E4E8;
        flex: 1;
      }
      .filter-last{
        padding-left: 10px;
        flex: 1;
      }
    }

  }
  .circle {
    display: inline-block;
    margin-right: 5px;
    width: 14px;
    height: 14px;
    min-width: 14px;
    min-height: 14px;
    border-radius: 100%;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
  }
  .purple {
     background: #6F42C1;
   }
   ::v-deep .el-table{
    .table-pointer{
      cursor: pointer;
    }
  }
  ::v-deep .el-table{
    border-radius: 4px;
    border: 1px solid #E1E4E8;
    tr{
      td{
        //display: flex;
        padding: 10px 15px 10px 0!important;
        vertical-align: top;
        margin-right: 15px;
        //height: 40px;
        .cell{
          //min-height: 40px;
          line-height: 23px;
          position: relative;
          height: inherit;
          //margin-left: 10px;
          //margin-right: 10px;
          padding: 0;
          //padding: 5px 10px;
          //position: absolute;
          //top: 10px;
        }
      }
    }
  }
  .flex-algin {
    /*display: flex;*/
    /*flex-direction: column;*/
    //justify-content: space-between;
    //font-weight: 500;
    &.time-text{
      font-size: 12px;
    }
    .icon-text{
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      letter-spacing: -0.15px;
      color: #24292E;
      margin-left: 15px;
    }
    .phone-text{
      font-size: 12px;
      color: #6A737D;
      .weight-text{
        font-weight: 600;
      }
    }
    &.period-text{
      span{
        font-size: 12px;
      }
    }
    p, span {
      min-height: 20px;
    }
    .first-text{
      color: #24292E;
      font-size: 14px;
    }
    .summary{
      font-size: 12px;
      word-break: break-word;
    }
    .status-height{
      height: 23px;
    }
  }
  .table-icon{
    &.margin-top-flex{
      margin-top: 5px;
    }
    .icon{
      margin-right: 10px;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #e1e4e8;
    }
    .backgroud-width{
      background: #fff!important;
      border: 1px solid #e1e4e8;
    }
  }
  ::v-deep .tableHeader {
    margin-top: 30px;
    background: #F6F8FA !important;
    border-bottom: 1px solid #E1E4E8;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      padding: 10px 0!important;
      color: #24292E!important;
      .cell{
        padding-left: 0;
      }
    }
    .button-border{
      display: inline-block;
      padding: 0px 10px;
      height: auto;
      //line-height: 30px;
      font-size: 12px;
      border-radius: 50px;
      border: 1px solid #E1E4E8;
      color: #24292E;
      background: white;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 18px;

    }
  }
}
</style>
